module.exports = __webpack_public_path__ + "static/media/animal_08_big.64c26c7e.png";